/*
 The MIT License (MIT)
 Copyright (c) 2013 Asaf David

 Permission is hereby granted, free of charge, to any person obtaining a copy of
 this software and associated documentation files (the "Software"), to deal in
 the Software without restriction, including without limitation the rights to
 use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 the Software, and to permit persons to whom the Software is furnished to do so,
 subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

define(['angular'], function(angular) {
    'use strict';

    angular.module('ecMultipleChart')
        .service('CSV', ['$q', function($q) {

            var EOL = '\r\n';
            var BOM = '\ufeff';

            /**
             * Stringify one field
             *
             * @param {*} data
             * @param {Object} options
             * @returns {*}
             */
            this.stringifyField = function(data, options) {
                if (options.decimalSep === 'locale' && this.isFloat(data)) {
                    return data.toLocaleString();
                }

                if (options.decimalSep !== '.' && this.isFloat(data)) {
                    return data.toString().replace('.', options.decimalSep);
                }

                if (typeof data === 'string') {
                    data = data.replace(/"/g, '""'); // Escape double qoutes

                    // keep leading 0 for numberString
                    // refers https://superuser.com/questions/318420/formatting-a-comma-delimited-csv-to-force-excel-to-interpret-value-as-a-string
                    if (/^[-]?[0-9]+[\.\,]?[0-9]+?$/.test(data)) {
                        data = '"=""' + data + '"""';
                    } else if (options.quoteStrings || data.indexOf(',') > -1 || data.indexOf('\n') > -1 || data.indexOf('\r') > -1) {
                        data = options.txtDelim + data + options.txtDelim;
                    }

                    return data;
                }

                if (typeof data === 'boolean') {
                    return data ? 'TRUE' : 'FALSE';
                }

                return data;
            };

            /**
             * Helper function to check if input is float
             *
             * @param {*} input
             * @returns {boolean}
             */
            this.isFloat = function(input) {
                return +input === input && (!isFinite(input) || Boolean(input % 1));
            };

            /**
             * Creates a csv from a data array
             *
             * @param {Object} data
             * @param {Object} options
             *  * header - Provide the first row (optional)
             *  * fieldSep - Field separator, default: ',',
             *  * addByteOrderMarker - Add Byte order mark, default(false)
             */
            this.stringify = function(data, options) {
                var def = $q.defer();

                var that = this;
                var csv = '';
                var csvContent = '';

                var dataPromise = $q.when(data).then(function(responseData) {
                    // Check if there's a provided title
                    if (angular.isDefined(options.title) && options.title) {
                        csvContent += options.title + EOL;
                    }

                    // Check if there's a provided header array
                    if (angular.isDefined(options.header) && options.header) {
                        var encodingArray, headerString;

                        encodingArray = [];
                        angular.forEach(options.header, function(title, key) {
                            this.push(that.stringifyField(title, options));
                        }, encodingArray);

                        headerString = encodingArray.join(options.fieldSep ? options.fieldSep : ',');
                        csvContent += headerString + EOL;
                    }

                    var arrData = [];

                    if (angular.isArray(responseData)) {
                        arrData = responseData;
                    } else if (angular.isFunction(responseData)) {
                        arrData = responseData();
                    }

                    // Check if using keys as labels
                    if (angular.isDefined(options.label) && options.label && typeof options.label === 'boolean') {
                        var labelArray, labelString;

                        labelArray = [];

                        var iterator = !!options.columnOrder ? options.columnOrder : arrData[0];
                        angular.forEach(iterator, function(value, label) {
                            var val = !!options.columnOrder ? value : label;
                            this.push(that.stringifyField(val, options));
                        }, labelArray);
                        labelString = labelArray.join(options.fieldSep ? options.fieldSep : ',');
                        csvContent += labelString + EOL;
                    }

                    angular.forEach(arrData, function(oldRow, index) {
                        var row = angular.copy(arrData[index]);
                        var dataString, infoArray;

                        infoArray = [];

                        var iterator = !!options.columnOrder ? options.columnOrder : row;
                        angular.forEach(iterator, function(field, key) {
                            var val = !!options.columnOrder ? row[field] : field;
                            this.push(that.stringifyField(val, options));
                        }, infoArray);

                        dataString = infoArray.join(options.fieldSep ? options.fieldSep : ',');
                        csvContent += index < arrData.length ? dataString + EOL : dataString;
                    });

                    // Add BOM if needed
                    if (options.addByteOrderMarker) {
                        csv += BOM;
                    }

                    // Append the content and resolve.
                    csv += csvContent;
                    def.resolve(csv);
                });

                if (typeof dataPromise['catch'] === 'function') {
                    dataPromise['catch'](function(err) {
                        def.reject(err);
                    });
                }

                return def.promise;
            };
        }]);

});



// WEBPACK FOOTER //
// ./components/multiple-chart/src/js/csv-service.js